import {isNumber} from "utils/IsNumber.js"
import {definitions} from './operations/index.js';

export const MAX_OPERATIONS = 12;
export default superclass => class extends superclass  {
    lastStepNumber = undefined;
    operationsCount = 0;
    onOperation(msg) {
        if (typeof msg !== "string") {
            return;
        }
        if (this.lastStepNumber !== this.zObject.sequencerEngine.trackStep) {
            this.operationsCount = 0;
        }
        if (this.operationsCount++ > MAX_OPERATIONS + 40) {
            return;
        }
        let tokens = msg.split(' ').filter(x => x !== '');
        let command = tokens[0];
        let args = tokens.slice(1).map(x => isNumber(x) ? parseFloat(x) : x);
        let fn = definitions[command];
        if (!fn) {
            return;
        }
        fn(this, ...args);
        this.lastStepNumber = this.zObject.sequencerEngine.trackStep;
    }
}
